import { motion } from 'framer-motion';
import { CSSProperties } from 'react';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

export default function Loader({ size = 'md', text }: LoaderProps) {
  const sizes = {
    sm: 24,
    md: 48,
    lg: 72
  };

  const containerStyles: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'var(--spacing-md)',
    padding: 'var(--spacing-2xl)'
  };

  const loaderSize = sizes[size];

  // NextAgency "X" inspired loader
  const xStyles: CSSProperties = {
    width: `${loaderSize}px`,
    height: `${loaderSize}px`,
    position: 'relative'
  };

  const arrowStyles: CSSProperties = {
    position: 'absolute',
    width: '40%',
    height: '100%',
    background: 'var(--color-primary)'
  };

  return (
    <div style={containerStyles}>
      <div style={xStyles}>
        <motion.div
          style={{ ...arrowStyles, clipPath: 'polygon(0 0, 100% 50%, 0 100%)' }}
          animate={{
            opacity: [0.3, 1, 0.3],
            x: [0, loaderSize * 0.2, 0]
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
        />
        <motion.div
          style={{
            ...arrowStyles,
            left: '30%',
            clipPath: 'polygon(0 0, 100% 50%, 0 100%)',
            background: 'var(--na-teal-light)'
          }}
          animate={{
            opacity: [0.3, 1, 0.3],
            x: [0, loaderSize * 0.2, 0]
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.2
          }}
        />
        <motion.div
          style={{
            ...arrowStyles,
            left: '60%',
            clipPath: 'polygon(0 50%, 100% 0, 100% 100%)',
            background: 'var(--color-secondary)'
          }}
          animate={{
            opacity: [0.3, 1, 0.3],
            x: [0, loaderSize * 0.1, 0]
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.4
          }}
        />
      </div>
      {text && (
        <motion.p
          style={{
            color: 'var(--color-text-secondary)',
            fontSize: '1rem',
            fontWeight: 500
          }}
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          {text}
        </motion.p>
      )}
    </div>
  );
}
